import Breadcrumb from "../../components/Breadcrumbs/Breadcrumb"
import ExamDetailComponent from "../../components/Exams/ExamDetailComponent"
import { useAuth } from "../../utils/Auth/AuthProvider";

const ExamDetail = () => {
  const { token, role } = useAuth();
  const isAllowed = !!token && (role === 'superuser' || role === 'school' || role === 'college_university');
  if (!isAllowed) {
    return (
      <div className="rounded border border-red-300 bg-red-50 p-4 text-red-700">403 - Not authorized</div>
    );
  }
  return (
    <>
      <Breadcrumb pageName="Exam Detail" />
      <ExamDetailComponent />
    </>
  )
}

export default ExamDetail